"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var state = {
  pageData: {
    list: [],
    selectKey: [],
    formList: [],
    config: {},
    templateName: "",
    industryId: "",
    channelCode: "",
    id: "",
    isPub: 0,
    remark: ""
  },
  selectWg: {},
  configTab: 'page',
  wgCollapse: "base",
  selectTheme: "",
  allAttrs: [],
  //所有的属性
  extraId: null,
  //业务ID - 当前操作的模板ID
  extraCurrAttrId: null,
  //当前操作的属性ID
  ossBase: null
};
var mutations = {
  setInitData: function setInitData(state) {
    state.pageData.list = [];
    state.pageData.selectKey = [];
    state.pageData.formList = [];
    state.pageData.config = {};
    state.pageData.id = "";
    state.pageData.isPub = 0;
    state.pageData.remark = "";
    state.selectWg = {};
    state.configTab = 'page';
    state.wgCollapse = "base";
    state.selectTheme = "";
    state.allAttrs = [];
    state.ossBase = null;
  },
  setPageData: function setPageData(state, payload) {
    state.pageData = payload;
  },
  setPageDataList: function setPageDataList(state, data) {
    state.pageData.list = data;
  },
  setSelectWg: function setSelectWg(state, payload) {
    state.selectWg = payload;
  },
  setConfigTab: function setConfigTab(state, payload) {
    state.configTab = payload;
  },
  setWgCollapse: function setWgCollapse(state, payload) {
    state.wgCollapse = payload;
  },
  setSelectTheme: function setSelectTheme(state, payload) {
    state.selectTheme = payload;
  },
  setAllAttrs: function setAllAttrs(state, payload) {
    state.allAttrs = payload;
  },
  setExtraId: function setExtraId(state, extraId) {
    //设置业务ID - 模板ID
    state.extraId = extraId;
  },
  setExtraCurrAttrId: function setExtraCurrAttrId(state, attrId) {
    //当前操作的属性ID
    state.extraCurrAttrId = attrId;
  },
  setOssBase: function setOssBase(state, ossBase) {
    state.ossBase = ossBase;
  }
};
var _default = exports.default = {
  state: state,
  mutations: mutations
};